var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFsl4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5301 0H16.4742V20.4347C16.4742 22.8696 14.5297 24.8696 12.1098 24.8696C9.68987 24.8696 7.74532 22.8696 7.74532 20.4347C7.74532 18.0435 9.64667 16.0869 11.9802 16V10.8696C6.83785 10.9565 2.68945 15.1739 2.68945 20.4347C2.68945 25.7392 6.92427 30 12.153 30C17.3817 30 21.6165 25.6957 21.6165 20.4347V9.9565C23.5179 11.3478 25.8513 12.1739 28.3145 12.2174V7.08696C24.5118 6.95652 21.5301 3.82608 21.5301 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFsl4);
export default __webpack_public_path__ + "static/media/fsl4.b9b87c658ed2a871582f1c51d82a7c2f.svg";
export { ForwardRef as ReactComponent };